<div class="specific-status-container">
    <!-- this is for specific status title eg.overall -->
    <div class="left-rounded alert-secondary" *ngIf="type">{{specifiedType | titlecase}}</div>
    <!-- for background color according to status -->

    <div [ngClass]="getClassname()"> {{formatStatusName(statusName)}}</div>
</div>